export default async function loaderStart({ context, nextMiddleware }) {
  try {
    console.log('loaderStart');
    context.store.loaderStore.setLoader({ show: true, manual: true });
  } catch (e) {
    console.error(e);
    return context.next(false);
  }
  return nextMiddleware();
}
